<agr-dialog [data]="data" (cancel)="dismiss()">
  <div class="dialog-content">
    <ul>
      @for (point of bulletPoints; track point) {
        <li>
          <span>{{ point }}</span>
        </li>
      }
    </ul>
  </div>
</agr-dialog>
